import { useTranslation } from 'react-i18next'

import * as Styles from './styles'

const BrandingPreview = ({ iframeRef, previewUrl }) => {
  const { t } = useTranslation()

  if (!previewUrl) return null

  return (
    <Styles.Container>
      <Styles.PreviewIframe
        ref={iframeRef}
        src={previewUrl}
        title={t('Vista previa de branding')}
        sandbox="allow-same-origin allow-scripts"
      />
    </Styles.Container>
  )
}

export default BrandingPreview
